module.exports = __webpack_public_path__ + "static/media/reportActiveIcon.bfce7218.svg";